import React from 'react';

function ChevronIcon(props) {
  const {
    color='#333333',
    ...otherProps
  } = props;

  return (
    <svg width='11px' height='8px' viewBox='0 0 11 8' version='1.1' xmlns='http://www.w3.org/2000/svg'>
        <g id='2139---Card-Filter' stroke='none' strokeWidth='2' fill='none' fillRule='evenodd' strokeLinecap='round'>
            <g transform='translate(-537.000000, -106.000000)' id='Group-Copy' strokeWidth='2' stroke={`${color}`}>
                <g transform='translate(538.000000, 107.000000)'>
                    <g id='Group-64'>
                        <path d='M4.5,6 L9,0' id='Shape'></path>
                        <path d='M0,0 L4.5,6' id='Shape'></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
  );
}

export default ChevronIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/ChevronIcon.js